import { FetchResult, gql } from 'apollo-boost';
import { IIpHolder } from '../../../models/ip-holder';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    {
        ip_holders {
            uid,
            identifier,
            name,
            url,
            details,
            createdAt: created_at,
            updatedAt: updated_at,
        }
    }
`;

export async function getAllIpHolders(): Promise<IIpHolder[]> {
    const result: FetchResult<{ ip_holders: IIpHolder[] }> = await graphqlClient.query({
        query: QUERY,
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.ip_holders;
}

